module.exports = __webpack_public_path__ + "assets/media/2.eb474185.wav";